import dayjs from "dayjs"

export const HOURS = [
  '00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23',
]

export const MINUTES = [
  '00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23',
  '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49',
  '50', '51', '52', '53', '54', '55', '56', '57', '58', '59', '60'
]

export const ERAS = [

  {
    //1989
    value: 'heisei ',
    content: '平成',
  },
  {
    //1926
    value: 'showa',
    content: '昭和',
  },
  {
    //2019
    value: 'reiwa',
    content: '令和',
  },
]

export const MONTH = [
  '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'
]

export const DATE = [
  '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23',
  '24', '25', '26', '27', '28', '29', '30'
]


export const HEISEI = [
  '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23',
  '24', '25', '26', '27', '28', '29', '30'
]

export const SHOWA = [
  '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23',
  '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49',
  '50', '51', '52', '53', '54', '55', '56', '57', '58', '59', '60'
]


export const formatJapaneseDate = (date: dayjs.Dayjs) => {
  return dayjs(date).toDate().toLocaleDateString("ja-JP-u-ca-japanese", {
    era: "long",
    month: "short",
    day: "numeric",
    year: "numeric",
  });
};